module.exports = __webpack_public_path__ + "fonts/Barlow-Bold.a7a7ea92.woff2";